import moment from 'moment';
import { ThreadSummary } from '@/experiences/sales-portal/domain/superintelligence/blocs/services/thread-api';

export type ThreadDateGroup =
  | 'older'
  | 'previous_7_days'
  | 'today'
  | 'yesterday';

export type ThreadRunState = 'running' | 'waiting';

const PREVIOUS_DAYS = 7;

export const threadDateGroup = (
  iso: string,
  now: Date = new Date(),
): ThreadDateGroup => {
  const day = moment(iso).startOf('day');
  const today = moment(now).startOf('day');
  const daysAgo = today.diff(day, 'days');
  if (daysAgo <= 0) {
    return 'today';
  }
  if (daysAgo === 1) {
    return 'yesterday';
  }
  return daysAgo <= PREVIOUS_DAYS ? 'previous_7_days' : 'older';
};

export const threadRunState = (
  summary: Pick<ThreadSummary, 'lastRun'> | undefined,
): ThreadRunState | null => {
  const run = summary?.lastRun;
  if (!run) {
    return null;
  }
  if (run.status === 'interrupted') {
    return 'waiting';
  }
  return run.status === 'running' && run.finishedAt === null ? 'running' : null;
};

export const matchesThreadSearch = (title: string, query: string) =>
  title.toLocaleLowerCase().includes(query.trim().toLocaleLowerCase());
